import React from 'react';
import { Button } from '@mui/joy';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { OpenInNewRounded } from '@mui-symbols-material/w300';
import { AssetNameplateBasicInfo } from '../../graphql/queries/assetNameplateBasicInfo';
import { buildServiceRequestUrl } from '../../utils/buildServiceRequestUrl';

interface Props {
    assetLocationId: string;
}

/**
 * Ghost/external action that opens the Pfeiffer Vacuum RMA (service request) portal for
 * this asset in a new tab. Mirrors ServiceRequestButton but rendered inline in the Hero
 * actions row (the icon button was removed from the top action bar).
 */
const HeroRmaAction = ({ assetLocationId }: Props) => {
    const { t, i18n } = useTranslation();

    const { data, loading } = useQuery(AssetNameplateBasicInfo, {
        variables: { id: assetLocationId },
        skip: !assetLocationId,
    });
    const asset = _.get(data, 'assetLocation.asset');

    const handleClick = () => {
        const url = buildServiceRequestUrl({
            serialNumber: _.get(asset, 'serialNumber'),
            productCode: _.get(asset, 'product.productCode'),
            productName: _.get(asset, 'product.name'),
            language: i18n.language,
        });
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <Button
            variant="plain"
            startDecorator={<OpenInNewRounded sx={{ fontSize: 20 }} />}
            disabled={loading || !asset}
            onClick={handleClick}
            sx={{ color: 'primary.500', '&:hover': { backgroundColor: 'rgba(0,0,0,0.02)' } }}
        >
            {t('Service request (RMA)')}
        </Button>
    );
};

export default HeroRmaAction;
